import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

export const getProperties = async (params = {}) => {
  const response = await api.get("/properties", { params });
  return response.data;
};

export const getProperty = async (id) => {
  const response = await api.get(`/properties/${id}`);
  return response.data;
};

export const submitRequest = async (path, data) => {
  const response = await api.post(path, data);
  return response.data;
};

export const exchangeDashboardSession = async (sessionId) => {
  const response = await api.post("/dashboard/auth/exchange", { session_id: sessionId });
  return response.data;
};

export const getDashboardUser = async () => {
  const response = await api.get("/dashboard/auth/me");
  return response.data;
};

export const logoutDashboard = async () => api.post("/dashboard/auth/logout");

export const getMandateOverview = async () => {
  const response = await api.get("/dashboard/overview");
  return response.data;
};

export const getMandateOpportunities = async (minimumScore) => {
  const response = await api.get("/dashboard/opportunities", {
    params: { minimum_score: minimumScore },
  });
  return response.data;
};

export const downloadMandateTourPdf = async (communeCode) => {
  const path = communeCode ? `/dashboard/communes/${communeCode}/tour.pdf` : "/dashboard/tour.pdf";
  const response = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url;
  link.download = communeCode ? `tournee-${communeCode}.pdf` : "tournee-du-jour.pdf";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const getMandateWorkflow = async () => {  const response = await api.get("/dashboard/workflow");
  return response.data;
};

export const runMandateWorkflow = async () => {
  const response = await api.post("/dashboard/workflow/run");
  return response.data;
};

export const sendMandateDigest = async () => {
  const response = await api.post("/dashboard/digest/send");
  return response.data;
};

export const getMandateMap = async () => {
  const response = await api.get("/dashboard/map");
  return response.data;
};

export const getMandateCommune = async (communeCode) => {
  const response = await api.get(`/dashboard/communes/${communeCode}`);
  return response.data;
};

export const getMandatePige = async () => {
  const response = await api.get("/dashboard/pige");
  return response.data;
};

export const approveMandateOpportunity = async (signalId) => {
  const response = await api.post(`/dashboard/opportunities/${signalId}/approve`);
  return response.data;
};

export const rejectMandateOpportunity = async (signalId, reason) => {
  const response = await api.post(`/dashboard/opportunities/${signalId}/reject`, { reason });
  return response.data;
};

export const getMandateAudit = async () => {
  const response = await api.get("/dashboard/audit");
  return response.data;
};

export const setMandatePipeline = async (signalId, stage) => {
  const response = await api.post(`/dashboard/opportunities/${signalId}/pipeline`, { stage });
  return response.data;
};